/* eslint-disable */
export default {
  currentCall: '현재 통화',
  viewCalls: '통화 보기',
  view: '보기',
  incomingCall: '수신 통화 {numberOf}통',
  incomingCalls: '수신 통화 {numberOf}통',
  callOnHold: '대기 중인 통화 {numberOf}통',
  callsOnHold: '대기 중인 통화 {numberOf}통',
  otherDeviceCall: '다른 디바이스에서 {numberOf}통의 전화',
  otherDeviceCalls: '다른 디바이스에서 {numberOf}통의 전화',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
